import React from 'react';
import {BannerStyled} from './Banner.styled'

const Banner: React.FC = () => {
    return (
        <BannerStyled>

        </BannerStyled>
    )
}

export default Banner;

